import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import flatpickr from 'flatpickr';
import { Uzbek } from 'flatpickr/dist/l10n/uz';

const uzLatnLocale = {
  ...Uzbek,
  weekdays: {
    shorthand: ['Yak', 'Dush', 'Sesh', 'Chor', 'Pay', 'Jum', 'Shan'],
    longhand: ['Yakshanba', 'Dushanba', 'Seshanba', 'Chorshanba', 'Payshanba', 'Juma', 'Shanba']
  },
  months: {
    shorthand: ['Yan', 'Fev', 'Mar', 'Apr', 'May', 'Iyun', 'Iyul', 'Avg', 'Sen', 'Okt', 'Noy', 'Dek'],
    longhand: [
      'Yanvar',
      'Fevral',
      'Mart',
      'Aprel',
      'May',
      'Iyun',
      'Iyul',
      'Avgust',
      'Sentabr',
      'Oktabr',
      'Noyabr',
      'Dekabr'
    ]
  },
  firstDayOfWeek: 1
};

const normalizeValue = value => {
  if (!value) return '';

  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return value;
  }

  if (/^\d{2}\.\d{2}\.\d{4}$/.test(value)) {
    const [day, month, year] = value.split('.');
    return `${year}-${month}-${day}`;
  }

  return '';
};

const UzDatePicker = ({ value, onChange, placeholder, className, ...rest }) => {
  const inputRef = useRef(null);
  const pickerRef = useRef(null);

  useEffect(() => {
    if (!inputRef.current) return undefined;

    pickerRef.current = flatpickr(inputRef.current, {
      locale: uzLatnLocale,
      dateFormat: 'Y-m-d',
      altInput: true,
      altFormat: 'd.m.Y',
      disableMobile: true,
      onChange: selectedDates => {
        if (!selectedDates.length) {
          onChange('');
          return;
        }

        const selected = selectedDates[0];
        const year = selected.getFullYear();
        const month = String(selected.getMonth() + 1).padStart(2, '0');
        const day = String(selected.getDate()).padStart(2, '0');
        onChange(`${year}-${month}-${day}`);
      }
    });

    return () => {
      if (pickerRef.current) {
        pickerRef.current.destroy();
      }
    };
  }, [onChange]);

  useEffect(() => {
    if (pickerRef.current) {
      pickerRef.current.setDate(normalizeValue(value) || '', false);
    }
  }, [value]);

  return <input ref={inputRef} className={className} placeholder={placeholder} {...rest} />;
};

UzDatePicker.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  className: PropTypes.string
};

UzDatePicker.defaultProps = {
  value: '',
  placeholder: 'Sanani tanlang',
  className: 'form-control'
};

export default UzDatePicker;
